import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Row, Col, Form, Modal } from 'react-bootstrap'
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import camera from '../assets/images/svg/camera.svg';
import { setLoginData } from '../redux/action/LoginAction';
import Loader from './Loader/Loader';

const Profile = (props) => {

    const dispatch = useDispatch()
    const serverURL = getServerURL()
    const fileInputRef = useRef(null);

    const [editModalShow, setEditModalShow] = useState(false);
    const [editProfileData, setEditProfileData] = useState({})
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(true)
    const profile = useSelector((item) => item?.login);
    const [subLoader, setSubLoader] = useState(false)
    const [profileData, setProfileData] = useState(profile || {});
    const [selectedImage, setSelectedImage] = useState()

    useEffect(() => {
        if (!Boolean(Object.keys(profileData)?.length)) getProfileData();
    }, []);

    const getProfileData = (event) => {
        api.getWithToken(`${serverURL}auth/profile/`)
            .then(async (res) => {
                setLoading(false)
                if (res?.data?.success === true) {
                    dispatch(setLoginData(res?.data?.data))
                    setProfileData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditProfileData((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
            setSelectedImage({
                [e.target.name]: e.target.files[0],
            });

            const formData = new FormData()
            formData.append("profile_img", e.target.files[0]);
            setSubLoader(true)
            api.postWithToken(`${serverURL}auth/profile-image-update/`, formData)
                .then(async (res) => {
                    getProfileData()
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getProfileData()
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    // setLoading(false);
                    //   errorResponse(e);
                });
        }

    };
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        setSubLoader(true)
        if (form.checkValidity()) {
            api.postWithToken(`${serverURL}auth/profile-update/`, editProfileData)
                .then(async (res) => {
                    setEditModalShow(false)
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getProfileData()
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    // errorResponse(e);
                });
            setValidated(false);
        } else {
            setValidated(true);
            event.stopPropagation();
        }
    };

    return (
        <div>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                            </header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setEditProfileData(profileData); setEditModalShow(true) }}>
                                {"Edit"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="d-flex p-4 gap-3">
                        <Row>
                            {Boolean(loading) ?
                                <Loader loading={loading} />
                                :
                                Boolean(Object.keys(profileData)?.length) &&
                                <div className="position-relative my-4" id="profile_image">
                                    <div className="d-flex justify-content-center align-items-center m-auto profileImage">
                                        <img
                                            src={selectedImage?.profile_img || profileData?.profile_img}
                                            onClick={handleImageClick}
                                            className={`cursor-pointer profile-image`}
                                        />
                                    </div>
                                    <input
                                        type="file"
                                        accept=".jpg, .jpeg, .png, webm, .webp"
                                        name="profile_img"
                                        style={{ display: "none" }}
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />

                                    <img
                                        src={camera}
                                        onClick={handleImageClick}
                                        className="cursor-pointer position-absolute top-50 start-50 translate-middle"
                                        alt=""
                                    />
                                </div>
                            }
                        </Row>
                        <div className="d-flex justify-content-between w-100 pl-4">
                            <table>
                                <tr>
                                    <td>Name :</td>
                                    <td className="ps-3">
                                        {profileData?.first_name + " " + profileData?.last_name || "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Email Id:</td>
                                    <td className="ps-3">
                                        {profileData?.email || "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>First Name:</td>
                                    <td className="ps-3">
                                        {profileData?.first_name || "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Last Name:</td>
                                    <td className="ps-3">
                                        {profileData?.last_name || "-"}
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td>Contact No:</td>
                                    <td className="ps-3">
                                        {profileData?.contact_no || "-"}
                                    </td>
                                </tr> */}
                            </table>
                        </div>

                    </div>
                </Card.Body>
            </Card>

            {/* edit Modal */}
            <Modal
                show={editModalShow}
                onHide={() => setEditModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h4">Edit {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        FirstName
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter FirstName" value={editProfileData?.first_name || ""} name='first_name' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalLastName">
                                    <Form.Label column sm={3}>
                                        LastName
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter LastName" value={editProfileData?.last_name || ""} name='last_name' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3}>
                                        Email
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="email" placeholder="Email" value={editProfileData?.email || ""} name='email' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end pt-2'>
                                    <Button type='submit' className='m-0'>Update</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Profile